<template>
  <v-container class="profile" fluid>
    <app-snackbar
    :text = "snackBarText"
    :show.sync = "snackbar"
    :color = "snackbarColor"
    :timeOut = "timeOut"
    ></app-snackbar>
    <coming-soon-modal :dialog.sync="dialog"></coming-soon-modal>
    <v-flex xs12 sm6 offset-sm3 class="flex">
      <div>
        <v-text-field class="font input-text" :readonly="!isNameEditable" prepend-inner-icon="face" :append-icon="iconEditName" @click:append="editName" name="name" id="name"
          v-model="User.name"
          :rules="$ponceConfig.nameRules"
          type="name"
          color="0099E1"
        ></v-text-field>
        <v-text-field class="font input-text" :readonly="!isPhoneEditable" prepend-inner-icon="phone" :append-icon="iconEditPhone" @click:append="editPhone" name="phone" id="phone"
          v-model="User.phone"
          :rules="$ponceConfig.phoneRules"
          type="text"
          color="0099E1"
        ></v-text-field>
        <v-text-field class="font input-text" :readonly="!isMailEditable" prepend-inner-icon="email" :append-icon="iconEditMail" @click:append="editMail" name="mail" id="mail"
          v-model="User.email"
          :rules="$ponceConfig.emailRules"
          type="mail"
          color="0099E1"
        ></v-text-field>
        <div class="change-password-div">
          <v-icon class="inline">lock</v-icon><p class="font inline change-password-text">Cambiar contraseña</p><v-icon class="inline to-right" @click="editPassword">email</v-icon>
        </div>
        <v-select prepend-icon="person" v-model="User.Role.id" v-on:change="editRole" item-text="label" item-value="id" :items="allRoles" ></v-select>
      </div>
    </v-flex>
  </v-container>
</template>

<script>
  import { USER_QUERY, UPDATE_USER_MUTATION, UPDATE_USER_ROLE_MUTATION, ALL_ROLES_QUERY } from '../../constants/graphql';
  export default {
    data () {
      return {
        User: {
          Role: {}
        },
        dialog: false,
        isNameEditable: false,
        isPhoneEditable: false,
        isMailEditable: false,
        allRoles: [],
        snackbar: false,
        snackBarText: '',
        snackbarColor: 'red',
        timeOut: 5000
      };
    },
    apollo: {
      User: {
        query: USER_QUERY,
        variables () {
          return {
            id: this.$store.getters.user.id
          };
        },
        result (result) {
          if (!result.data.User.Role) {
            result.data.User.Role = {};
          }
        }
      },
      allRoles: {
        query: ALL_ROLES_QUERY
      }
    },
    computed: {
      iconEditName () {
        if (this.isNameEditable) {
          return 'check';
        } else {
          return 'edit';
        }
      },
      iconEditMail () {
        if (this.isMailEditable) {
          return 'check';
        } else {
          return 'edit';
        }
      },
      iconEditPhone () {
        if (this.isPhoneEditable) {
          return 'check';
        } else {
          return 'edit';
        }
      }
    },
    methods: {
      editName () {
        if (!this.$store.getters.isOnline) {
          this.snackbar = true;
          this.snackBarText = 'Sin conexión! Intenta nuevamente más tarde';
          this.snackbarColor = 'red';
          return;
        }
        if (!this.isNameEditable) {
          this.isNameEditable = true;
        } else {
          if (this.User.name && this.User.name.length) {
            this.$apollo.mutate({
              mutation: UPDATE_USER_MUTATION,
              variables: {
                id: this.$store.getters.user.id,
                name: this.User.name
              }
            }).then(() => {
              this.snackbar = true;
              this.snackBarText = 'El nombre fue actualizado';
              this.snackbarColor = 'green';
            }).catch(() => {
            });
          }
          this.isNameEditable = false;
        }
      },
      editPhone () {
        if (this.$store.getters.isOnline) {
          if (!this.isPhoneEditable) {
            this.isPhoneEditable = true;
          } else {
            if (this.User.phone && this.User.phone.length) {
              this.$apollo.mutate({
                mutation: UPDATE_USER_MUTATION,
                variables: {
                  id: this.$store.getters.user.id,
                  phone: this.User.phone
                }
              }).then(() => {
                this.snackbar = true;
                this.snackBarText = 'El teléfono fue actualizado';
                this.snackbarColor = 'green';
              }).catch(() => {
              });
            }
            this.isPhoneEditable = false;
          }
        } else {
          this.snackbar = true;
          this.snackBarText = 'Sin conexión! Intenta nuevamente más tarde';
          this.snackbarColor = 'red';
        }
      },
      editMail () {
        if (this.$store.getters.isOnline) {
          if (!this.isMailEditable) {
            this.isMailEditable = true;
          } else {
            if (this.User.email && this.User.email.length) {
              this.$apollo.mutate({
                mutation: UPDATE_USER_MUTATION,
                variables: {
                  id: this.$store.getters.user.id,
                  email: this.User.email
                }
              }).then(() => {
                this.snackbar = true;
                this.snackBarText = 'El mail fue actualizado';
                this.snackbarColor = 'green';
              }).catch(() => {
              });
            }
            this.isMailEditable = false;
          }
        } else {
          this.snackbar = true;
          this.snackBarText = 'Sin conexión! Intenta nuevamente más tarde';
          this.snackbarColor = 'red';
        }
      },
      editRole () {
        if (this.$store.getters.isOnline) {
          this.$apollo.mutate({
            mutation: UPDATE_USER_ROLE_MUTATION,
            variables: {
              userId: this.$store.getters.user.id,
              roleId: this.User.Role.id
            }
          }).then(() => {
            this.snackbar = true;
            this.snackBarText = 'El rol fue actualizado';
            this.snackbarColor = 'green';
          }).catch(() => {
          });
        } else {
          this.snackbar = true;
          this.snackBarText = 'Sin conexión! Intenta nuevamente más tarde';
          this.snackbarColor = 'red';
        }
      },
      editPassword () {
        this.dialog = true;
      }
    }
  };
</script>



// WEBPACK FOOTER //
// Profile.vue?864b9eea